export class TabNavigation {
  constructor(categories) {
    this.categories = categories;
    this.activeTab = categories[0]?.id || 'antipasti';
  }

  render() {
    const tabsHtml = this.categories.map(category => `
      <div class="tab ${category.id === this.activeTab ? 'active' : ''}" 
           data-tab="${category.id}">
        <i class="fas ${category.icon} tab-icon"></i>
        <span>${category.name}</span>
      </div>
    `).join('');

    return `
      <div class="tabs-container">
        <div class="tabs-scroll-container">
          <div class="tabs">
            ${tabsHtml}
          </div>
          <div class="scroll-indicator"></div>
        </div>
      </div>
    `;
  }

  bindEvents(onTabChange) {
    document.querySelectorAll('.tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-tab');
        this.setActiveTab(targetId);
        onTabChange(targetId);
        
        // Scroll tab into view
        tab.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'nearest', 
          inline: 'center' 
        });
      });
    });
  }

  setActiveTab(tabId) {
    this.activeTab = tabId;
    
    // Update tab states
    document.querySelectorAll('.tab').forEach(tab => {
      tab.classList.toggle('active', tab.getAttribute('data-tab') === tabId);
    });
  }
}